<template>
  <div class="tinymce">
    <el-button class="uploadBtn" type="default" @click="uploadViedoBtn">上传视频</el-button>
    <editor id="tinymce" v-model="contents" :init="editorInit" style="width: 90%" />
    <el-dialog title="上传视频" :visible.sync="visible" width="30%" :before-close="handleClose">
      <el-upload class="upload-demo" drag action="" :auto-upload="false" :http-request="uploadFile" :on-change="onChange" :limit="1" accept=".mp4" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传mp4文件，且不超过5M</div>
      </el-upload>
      <div class="btn">
        <el-button type="primary" :disabled="!file" @click="uploadFile">确定上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/memPlan";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/modern/theme";
import "tinymce/plugins/image";

import "tinymce/plugins/media";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/preview";
export default {
  name: "Index",
  scrollerHeight: {
    content: String,
    default: "",
  },
  props: {
    content: {
      type: String,
      default: "",
    },
    value: {},
  },
  components: {
    Editor,
  },
  mounted () {
    tinymce.init({});
  },
  beforeMount () {
    // 接收 v-model 数据
    if (this.value) {
      this.contents = this.value;
    }
  },
  data () {
    return {
      visible: false,
      file: null,
      fileList: [],
      videomsg: "",
      uploadFlg: false,
      contents: this.content,
      editorInit: {
        language_url:
          process.env.NODE_ENV === "development"
            ? "/static/tinymce/langs/zh_CN.js"
            : "/shop/static/tinymce/langs/zh_CN.js", //语言包的路径
        language: "zh_CN", //语言
        skin_url:
          process.env.NODE_ENV === "development"
            ? "/static/tinymce/skins/lightgray"
            : "/shop/static/tinymce/skins/lightgray", //skin路径
        plugins:
          "preview link lists image   code table colorpicker textcolor wordcount contextmenu",
        toolbar:
          "preview | bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image  code | removeformat",
        height: 500, //编辑器高度
        branding: false, //是否禁用“Powered by TinyMCE”
        images_upload_handler: (blobInfo, success, failure) => {
          let formdata = new FormData();
          formdata.set("multipart", blobInfo.blob());
          formdata.set("pid", 5);
          formdata.set("model", "news");
          api.uploadImg(formdata).then((res) => {
            const img = res.url;
            success(img);
          });
        },
        file_picker_types: "media",
        media_live_embeds: true,
        file_picker_callback: (callback, value, meta) => {
          if (meta.filetype === "media") {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            const that = this; // 为 Vue 构造函数中的 this，指向 Vue 实例对象
            input.onchange = async function () {
              const file = this.files[0]; // 为 HTMLInputElement 构造函数中的 this，指向 input 实例对象
              const isValid = await that.validateVideo(file);
              if (isValid) {
                const loading = that.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                await that.uploadFile(file, "video");
                if (that.uploadFlg) {
                  callback(that.videomsg);
                  loading.close();
                } else {
                  setTimeout(() => {
                    callback(that.videomsg);
                    loading.close();
                  }, 2000);
                }
              } else {
                callback();
              }
            };
            input.click();
          }
        },
        //预览上传的视频
        media_url_resolver: (data, resolve) => {
          try {
            let videoUri = encodeURI(data.url);
            let embedHtml = `<p>
                        <span
                            class="mce-object mce-object-video"
                            data-mce-selected="1"
                            data-mce-object="video"
                            data-mce-p-width="100%"
                            data-mce-p-height="auto"
                            data-mce-p-controls="controls"
                            data-mce-p-controlslist="nodownload"
                            data-mce-p-allowfullscreen="true"
                            data-mce-p-src=${videoUri} >
                            <video src=${data.url} width="50%" height="60%" controls="controls" controlslist="nodownload">
                            </video>
                        </span>
                        </p>
                        <p style="text-align: left;"></p>`;
            resolve({ html: embedHtml });
          } catch (e) {
            resolve({ html: "" });
          }
        },
      },
    };
  },
  watch: {
    content: function (val) {
      this.contents = this.content;
    },
    contents: function (val) {
      this.$emit("input", val);
    },
  },
  mounted () {
    window.addEventListener('paste', this.handlePaste);
  },
  beforeDestroy () {
    window.removeEventListener('paste', this.handlePaste);
  },
  methods: {
    handlePaste (e) {
      const clipboardData = window.clipboardData || e.originalEvent.clipboardData;
      let pastedText = '';
      try {
        pastedText = clipboardData.getData('text');
      } catch (error) {
        // 处理异常情况
      }
      this.$refs.richTextEditor.insertText(pastedText);
    },
    uploadViedoBtn () {
      this.visible = true;
    },
    handleClose () {
      this.visible = false;
      this.file = null;
      this.fileList = [];
    },
    //校验视频格式和内存大小
    validateVideo (file) {
      console.log("validateVideo");
      const isMP4 = file.type === "video/mp4";
      const isLt1G = file.size / 1024 / 1024 < 512;
      if (!isMP4) {
        this.$message.error("上传视频必须为 MP4 格式！");
        return false;
      }
      if (!isLt1G) {
        this.$message.error("上传视频大小限制 5M 以内！");
        return false;
      }
      const duration = this.getVideoDuration(file);
      if (duration > 60) {
        this.$message.error("上传视频时长不能超过 60 秒！");
        return false;
      }
      return true;
    },
    //获取视频源
    getVideoDuration (file) {
      return new Promise((resolve) => {
        const videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);

        videoElement.addEventListener("loadedmetadata", () => {
          resolve(videoElement.duration);
        });
      });
    },
    onChange (file) {
      let valid = this.validateVideo(file.raw);
      if (valid) {
        this.file = file.raw;
      } else {
        this.file = null;
        this.fileList = [];
      }
    },

    //上传视频
    uploadFile () {
      const formData = new FormData();
      formData.append("multipart", this.file);
      api.uploadVideo(formData).then((res) => {
        this.videomsg = res;
        this.uploadFlg = true;
        this.$message.success("上传成功");
        //上传成功之后往编辑里插入视频
        window.tinymce.get("tinymce").insertContent(
          `<p>
              <span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=${res} data-mce-html="%20">
                  <video src=${res} width="420" controls="controls"></video>
              </span>
            </p>`
        );
        this.handleClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tinymce {
  position: relative;
  .el-icon-upload {
    margin: 16px 0;
  }
  .el-upload-dragger {
    height: 130px;
  }
  .el-upload__tip {
    margin-top: 0;
  }
  .upload-demo {
    text-align: center;
  }
  .uploadBtn {
    position: absolute;
    top: 0;
    z-index: 999;
    right: 10%;
  }
  .btn {
    text-align: center;
    margin-top: 6px;
  }
}
</style>
